var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfluencer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 5)",
    stroke: "#314E55",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.458 22.951C16.733 27.616 20.523 31 25 31c4.477 0 8.267-3.384 9.542-8.049h0a3 3 0 00.24-5.848C33.824 11.903 29.808 8 25 8s-8.824 3.902-9.782 9.103a3.001 3.001 0 00.24 5.848zM36 42c0-6.075-4.925-11-11-11s-11 4.925-11 11h22z",
    fill: "#E9E7D1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EA86A5",
    cx: 46,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5ECB66",
    cx: 5,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EA86A5",
    cx: 3,
    cy: 34,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5ECB66",
    cx: 45,
    cy: 49,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.254 33.051l7.064-4.108M7.66 5.653l5.416 3.73M44.42 5.851l-6.667 6.186M43.806 46.17l-8.134-16.103"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencer);
export default __webpack_public_path__ + "static/media/influencer.b619d3a92aa93ca3a07c50285585e15c.svg";
export { ForwardRef as ReactComponent };